import { render } from "./VendorsShowDialogAttachment.vue?vue&type=template&id=68ec6b4a"
import script from "./VendorsShowDialogAttachment.vue?vue&type=script&lang=js"
export * from "./VendorsShowDialogAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__